import React from 'react'

import { DataManagementSoftware } from '@components/cases/DataManagementSoftware'
import { CustomHead } from '@ui/sections/CustomHead'

function TrackingAppPage() {
  return (
    <>
      <CustomHead
        title="Comprehensive data management software"
        description="Discover the approach Modsen team implemented to deliver a high-end software solution for effective data management."
        imagePath="/images/cases/data-management-software/opengraph.webp"
      />
      <DataManagementSoftware />
    </>
  )
}

export default TrackingAppPage
